import Meeting, {MeetingAttachment} from './Meeting'
import MeetingCommentView from './MeetingCommentView'
import DeletedCommentView from './DeletedCommentView'
import {Nullable} from '../../../app/TypeHelpers'
import {AVAILABLE_OR_NOT, VALID_OR_NOT} from '../../../CodeMaster'
import {Moment} from 'moment'

export class MeetingWithComments extends Meeting {
    meetingCommentList: (MeetingCommentView | DeletedCommentView)[]

    constructor(
        id: number,
        name: string,
        date: string,
        startTime: Nullable<string>,
        endTime: Nullable<string>,
        place: Nullable<string>,
        url: Nullable<string>,
        contents: Nullable<string>,
        memo: Nullable<string>,
        attendanceReplyDeadline: Nullable<Moment>,
        attendanceReplyRequestDatetime: Nullable<Moment>,
        manageAttendance: VALID_OR_NOT,
        proxyAttendanceAvailability: Nullable<AVAILABLE_OR_NOT>,
        meetingAnnounceNotifyDatetime: Nullable<Moment>,
        meetingAttachmentFileList: MeetingAttachment[],
        meetingAttachmentLinkList: MeetingAttachment[],
        meetingReportList: MeetingAttachment[],
        meetingCommentList: (MeetingCommentView | DeletedCommentView)[],
        version: number,
    ) {
        super(
            id,
            name,
            date,
            startTime,
            endTime,
            place,
            url,
            contents,
            memo,
            attendanceReplyDeadline,
            attendanceReplyRequestDatetime,
            manageAttendance,
            proxyAttendanceAvailability,
            meetingAnnounceNotifyDatetime,
            meetingAttachmentFileList,
            meetingAttachmentLinkList,
            meetingReportList,
            version,
        )
        this.meetingCommentList = meetingCommentList
    }
}
